import { InjectionToken } from '@angular/core';
import { ShopTone } from '@digilize/shared/definitions/src';

/**
 * The register an app's **base** `nl.json` is written in. The overlay carries the other one.
 *
 * `TranslocoHttpLoader` fetches an overlay only when the shop's tone differs from this, so an app
 * whose base already matches the shop pays no extra request. Which register belongs in the base is a
 * per-app decision, not a global one:
 *
 * - **Formal** (the default) for `pauly-shop` and `pauly-auth`. Their Dutch was written with "u / uw"
 *   and every shop is `tone: 0`, so the common case needs no overlay and a gap degrades to formal.
 * - **Informal** for `pauly-order2seat`, whose Dutch is entirely "je / jij" — rewriting it would flip
 *   every cinema's seat-QR app to "u" on ship, which is not what was wanted (PAUL-3464).
 *
 * The trade-off of an informal base is that the safe direction inverts: there, a key missing from
 * `nl-formal.json` shows "je" to a shop that asked for "u". `tone.spec.ts` in the app that owns the
 * files is what holds the two in step, and it is load-bearing rather than a nicety.
 */
export const TRANSLATION_BASE_TONE = new InjectionToken<ShopTone>('TRANSLATION_BASE_TONE', {
  providedIn: 'root',
  factory: () => ShopTone.Formal,
});
